import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import { Button } from 'bootstrap';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import RTE from 'shared/components/rte/rte.jsx';
import { Map } from 'immutable';

export default React.createClass({
  mixins: [
    Reflux.connectFilter(
      CuesheetStore,
      'rowState',
      ModalHelper.itemConnectFilter(
        (row) => row.getIn(['editing', 'type']) === EditableCellTypes.Data,
      ),
    ),
    Reflux.connectFilter(CuesheetStore, 'columns', (st) => st.get('columns')),
  ],

  displayName: 'ItemDataCellModal',

  render() {
    let { rowState, columns } = this.state;

    if (!rowState) return null;

    return (
      <Modal
        className="csr-modal-item-title-wrapper"
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title={columns.getIn([rowState.columnId, 'title'])}
      >
        <div className="csr-modal-item-title-content">
          {this._getInputNode()}
          <Button onClick={this._handleDone}>Save</Button>
        </div>
      </Modal>
    );
  },

  _getInputNode() {
    let { rowState } = this.state;

    let { item, columnId } = rowState;

    return (
      <RTE
        ref="rte"
        displayToolbar={false}
        readOnly={false}
        autoFocus
        rteState={item.getIn(['cells', columnId, 'rteState'])}
        disableBlur
      />
    );
  },

  _handleDone() {
    const rteState = this.refs.rte.getValue();

    // rowIndex, rowId, columnId
    const { rowId, columnId } = this.state.rowState;

    const cellSpec = Map({ type: EditableCellTypes.Data, value: columnId });

    CuesheetCellActions.saveDataCellChanges(rowId, cellSpec, rteState);

    ModalActions.hide(this._getModalId());
  },

  _getModalId() {
    return UIRegions.CuesheetItemCell;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(this._getModalId());
    }
  },
});
